var _circle, _rect, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 174,
    viewBox: "0 0 194 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.6519,
    cy: 83.2456,
    r: 73,
    stroke: "#131673",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6519,
    y: 20.2456,
    width: 126,
    height: 126,
    rx: 63,
    stroke: "#FEDA00",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.6519,
    cy: 83.2456,
    r: 60,
    fill: "#FE0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.961 77.3956C109.481 78.2956 113.711 80.3656 116.651 83.6056C119.591 86.7856 121.061 90.7456 121.061 95.4856C121.061 99.1456 120.101 102.536 118.181 105.656C116.261 108.716 113.321 111.176 109.361 113.036C105.461 114.896 100.661 115.826 94.961 115.826C90.521 115.826 86.141 115.256 81.821 114.116C77.561 112.916 73.931 111.236 70.931 109.076L76.601 97.9156C79.001 99.7156 81.761 101.126 84.881 102.146C88.061 103.106 91.301 103.586 94.601 103.586C98.261 103.586 101.141 102.896 103.241 101.516C105.341 100.076 106.391 98.0656 106.391 95.4856C106.391 90.3256 102.461 87.7456 94.601 87.7456H87.941V78.1156L100.901 63.4456H74.081V51.7456H118.181V61.1956L103.961 77.3956Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4079 69.1242C12.8441 65.5361 9.32275 61.1159 4.78496 56.3219C10.5059 53.857 15.6362 53.4779 20.8772 53.1979C21.0428 58.5341 19.5398 65.5513 17.4079 69.1242ZM17.9637 56.3115C15.1956 56.7363 13.0046 57.0675 10.3909 57.462C12.3375 59.8686 13.6085 62.2943 16.6669 63.4497C17.1012 61.0642 17.4663 59.0669 17.9637 56.3115Z",
    fill: "#00BDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8034 32.8951C20.5153 33.4131 24.9871 36.0225 30.3018 38.4242C27.786 42.4995 25.5782 46.0825 22.9602 50.3363C19.1816 44.7009 16.0173 39.814 13.8034 32.8951ZM25.9446 40.1797L18.2302 36.6935C20.0364 39.8964 21.2089 41.9675 22.6958 44.598C23.9761 42.8541 24.8799 41.6357 25.9535 40.1837L25.9446 40.1797Z",
    fill: "#00BDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6608 34.1038C30.6174 28.6179 29.1045 23.721 27.9658 17.5194C34.3668 19.3051 38.6981 22.7025 43.7501 25.5405C41.1904 29.5333 37.2627 31.1155 33.657 34.1128L33.6608 34.1038ZM34.6199 29.7574C36.3113 28.2583 37.382 27.3086 38.8485 26.0097L32.3876 23.2094C33.2089 25.6063 33.7467 27.2105 34.6199 29.7574Z",
    fill: "#00BDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7207 23.1026C44.6321 17.6421 43.0789 12.7578 41.889 6.56575C48.3045 8.29863 52.6637 11.6601 57.7389 14.4563C55.2123 18.4701 51.2977 20.0846 47.7169 23.1116L47.7207 23.1026ZM48.6438 18.7485C50.3228 17.2355 51.3856 16.277 52.8414 14.9659L46.3576 12.2191C47.1987 14.6091 47.7496 16.2089 48.6438 18.7485Z",
    fill: "#00BDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.362 105.373C182.755 109.168 186.068 113.746 190.38 118.744C184.551 120.942 179.409 121.084 174.161 121.122C174.242 115.784 176.067 108.843 178.362 105.373ZM177.215 118.146C180 117.85 182.203 117.62 184.833 117.347C182.999 114.853 181.842 112.371 178.84 111.075C178.296 113.438 177.839 115.417 177.215 118.146Z",
    fill: "#00BDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.769 139.834C174.047 139.464 169.519 136.953 164.153 134.668C166.579 130.539 168.707 126.908 171.231 122.598C175.132 128.149 178.403 132.965 180.769 139.834ZM168.47 132.818L176.26 136.134C174.383 132.971 173.166 130.926 171.621 128.329C170.38 130.101 169.503 131.339 168.461 132.814L168.47 132.818Z",
    fill: "#00BDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.889 139.062C164.052 144.479 165.672 149.342 166.947 155.517C160.508 153.872 156.104 150.571 150.99 147.844C153.462 143.796 157.354 142.128 160.893 139.053L160.889 139.062ZM160.026 143.428C158.368 144.964 157.318 145.937 155.881 147.268L162.401 149.926C161.528 147.547 160.955 145.955 160.026 143.428Z",
    fill: "#00BDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.074 150.369C150.282 155.76 151.942 160.609 153.268 166.774C146.816 165.182 142.384 161.917 137.248 159.233C139.686 155.165 143.564 153.464 147.078 150.36L147.074 150.369ZM146.247 154.742C144.601 156.292 143.56 157.273 142.133 158.616L148.676 161.22C147.783 158.849 147.197 157.261 146.247 154.742Z",
    fill: "#00BDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.f6ff3a5b8e5fe9fba1dba29d5cc4ad30.svg";
export { ForwardRef as ReactComponent };